import axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import {url} from 'utils/url';
import { errorMsg, refreshToken } from 'utils';

export const RESPONDENT_FETCH_DATA_INIT = createAction(
  'RESPONDENT_FETCH_DATA_INIT'
);
export const RESPONDENT_FETCH_DATA_SUCCESS = createAction(
  'RESPONDENT_FETCH_DATA_SUCCESS'
);
export const RESPONDENT_FETCH_DATA_FAIL = createAction(
  'RESPONDENT_FETCH_DATA_FAIL'
);

axios.defaults.withCredentials = true;

export const fetchRespondent = ({ id }) => {
  // eslint-disable-next-line
  return async (dispatch, getState) => {
    dispatch(RESPONDENT_FETCH_DATA_INIT());
    if (id) {
      let respondentData;
      try {
        const token = await refreshToken();
        respondentData = await axios.get(`${url}/respondent/get`, {
          params: {
            id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
      } catch (error) {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(RESPONDENT_FETCH_DATA_FAIL({ error }));
      }

      const respondent = {
        ...respondentData.data.data,
        id: id,
      };
      return dispatch(
        RESPONDENT_FETCH_DATA_SUCCESS({
          list: getState().respondent.list,
          respondent,
        })
      );
    }
  };
};
